import axios from 'axios';
import { constructServiceURL } from '../../../../../utils/URLTools';

const apiFetchRfidFileDelete = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'deleteRfidFile',
    stub: process.env.useStubbedEndpoints,
  });
  return axios.delete(serviceUrl, {
    data: {
      fileIds: payload.params.fileIds,
    },
  });
};

export default apiFetchRfidFileDelete;
